<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div v-if="resData" style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-input
                          v-model="form.admin_name"
                          placeholder="次品员"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="resData"
                          v-model="form.dgid"
                          placeholder="次品组"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.options.group"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.city"
                          placeholder="城市"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.options.city"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.character"
                          placeholder="角色"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.options.character"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.role_type"
                          placeholder="成员身份"
                          filterable
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in constantMap.membershipOptions"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.status"
                          placeholder="状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in resData.options.status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="6">
                        <el-date-picker
                          v-model="form.create_time"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        >
                        </el-date-picker>
                      </el-col>
                      <el-col :span="2">
                        <el-button type="primary" @click="search">
                          查询</el-button
                        >
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据汇总 ：{{ resData.count }}人</div>
          <el-button
            style="margin-left: auto"
            type="warning"
            size="mini"
            @click="AddMember"
            >创建次品员
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="dg_member_id"
              label="次品员id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="次品员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="defective_group_member_character"
              label="角色"
              align="center"
            ></el-table-column>
            <el-table-column prop="role_type" label="成员身份" align="center">
              <template #default="{ row }">
                <span>{{
                  constantMap.membershipOptions.find(
                    (item) => item.value === row.role_type
                  ).label
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="group_names"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="defective_group_member_city"
              label="城市"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_num"
              label="绑定商家数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="defective_group_member_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
              <template #default="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="editMember(scope.row.dg_member_id)"
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="showLogList(scope.row.dg_member_id)"
                  >操作日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.page"
            background
            layout="total, prev, sizes,pager, next, jumper "
            :total="resData.count"
            :page-size="50"
            :page-sizes="[10, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="添加/编辑次品员"
      width="20%"
      :visible.sync="showbox"
      :before-close="closeEditDefectiveMember"
    >
      <el-form
        ref="memberRef"
        :model="member_form"
        label-width="100px"
        label-position="left"
        :rules="memberFormRules"
      >
        <el-form-item label="次品员" prop="admin_id">
          <el-select
            v-if="!admin_disabled"
            id="no_member"
            v-model="member_form.admin_id"
            filterable
          >
            <el-option
              v-for="item in options.admin"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-select
            v-if="admin_disabled"
            id="has_member"
            v-model="member_form.admin_id"
            disabled
          >
            <el-option
              :label="member_form.admin_name"
              :value="member_form.admin_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色" prop="character">
          <el-select v-model="member_form.character" filterable>
            <el-option
              v-for="item in options.character"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="成员身份" prop="role_type">
          <el-select v-model="member_form.role_type" filterable>
            <el-option
              v-for="item in constantMap.membershipOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="绑定城市" prop="city">
          <el-select v-model="member_form.city">
            <el-option
              v-for="item in options.city"
              v-show="item.value > 0"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定次品组" prop="dgids">
          <el-select v-model="member_form.dgids" filterable multiple>
            <el-option
              v-for="item in options.group"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="member_form.status">
            <el-option
              v-for="item in options.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDefectiveMember">
          取 消</el-button
        >
        <el-button size="small" type="primary" @click="saveDefectiveMember">
          确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :before-close="closeLogBox" :visible.sync="showlog">
      <el-table :data="loglist" style="width: 100%" height="250">
        <el-table-column fixed prop="action_type" label="事件">
        </el-table-column>
        <el-table-column width="350" label="内容" align="center">
          <template #default="scope">
            <div v-html="scope.row.action_desc" />
          </template>
        </el-table-column>
        <el-table-column prop="action_admin" label="操作人"> </el-table-column>
        <el-table-column prop="create_time" label="操作时间"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

const constantMap = Object.freeze({
  membershipOptions: [
    { label: "组长", value: "1" },
    { label: "组员", value: "2" },
    { label: "第三方驻点", value: "3" },
  ],
  groupLeader: "1",
});

export default {
  data() {
    return {
      constantMap,
      log_type: 2,
      id: 0,
      showlog: false,
      showbox: false,
      admin_disabled: false,
      images: [],
      resData: null,
      form: {
        status: "",
        dgid: "",
        city: "",
        admin_name: "",
        p: 1,
        psize: 50,
        character: "",
      },
      member_form: {
        status: "1",
        dgids: [],
      },
      memberFormRules: {
        admin_id: {
          required: true,
          message: "请选择次品员",
          trigger: "change",
        },
        character: {
          required: true,
          message: "请选择角色",
          trigger: "change",
        },
        role_type: {
          required: true,
          message: "请选择成员身份",
          trigger: "change",
        },
        city: {
          required: true,
          message: "请选择城市",
          trigger: "change",
        },
        dgids: {
          required: true,
          message: "请选择次品组",
          trigger: "change",
          type: "array",
        },
        status: {
          required: true,
          message: "请选择状态",
          trigger: "change",
        },
      },
      loglist: [],
      options: {
        city: {},
        status: {},
        group: {},
        admin: {},
        character: [],
      },
      loading: false, // 加载动画是否显示
      url: "/erp/Defective/getMembers",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
      picker: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    const { pgid } = this.$route.query;
    if (pgid != "undefined" && pgid != null && pgid != "" && pgid) {
      this.form.pgid = pgid;
    }
    this.fetchData();
  },
  methods: {
    hanlePg(data) {
      if (!data) {
        return [];
      }
      const re = data.split(",");
      return re;
    },
    handleClick(id) {
      this.$router.push(`/home/supply/supplyList?pg_member_id=${id}`);
    },
    showLogList(id) {
      this.$http
        .post("/erp/Defective/getLog", {
          type: "member",
          id,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loglist = res.data.data.log;
            this.showlog = true;
          }
        });
    },
    AddMember() {
      this.$http.post("/erp/Defective/getSelectOption").then((res) => {
        if (res.data.code == 200) {
          this.admin_disabled = false;
          this.showbox = true;
          this.options = res.data.data.options;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    editMember(id) {
      this.$http
        .post("/erp/Defective/getMemberDetail", {
          dg_member_id: id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.admin_disabled = true;
            this.showbox = true;
            this.member_form = res.data.data.detail;
            this.options = res.data.data.options;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    closeBox() {
      this.showbox = false;
      this.showlog = false;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleSizeChange(val) {
      this.form.psize = val;
      this.form.p = 1;
      this.loading = true;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.form.p = val;
      this.loading = true;
      this.fetchData();
    },
    search() {
      this.form.p = 1;
      this.fetchData();
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    closeEditDefectiveMember() {
      this.showbox = false;
      this.options = {
        admin: {},
      };
      this.member_form = {
        status: "1",
      };
    },
    closeLogBox() {
      this.showlog = false;
      this.loglist = null;
    },
    saveDefectiveMember() {
      this.$refs.memberRef.validate((valid) => {
        if (valid) {
          this.$http
            .post("/erp/Defective/saveMembers", this.member_form)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success("编辑成功");
                this.closeEditDefectiveMember();
                this.fetchData();
              }
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/defectivegroup/member.vue